module.exports = __webpack_public_path__ + "img/swiper2.40d9d009.png";